
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'QuizProgress',
  computed: {
    ...mapGetters('quiz', ['getQuizCurrentIndex', 'getQuizList', 'getQuizReferrerLink', 'getProductType']),
  },
  methods: {
    ...mapActions('quiz', ['setQuizCurrentIndexAction', 'setQuizStepFrom', 'setQuizStepTo']),
    scrollToTop() {
      if (window) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
    goBackHandler() {
      if (this.getQuizCurrentIndex === 0) {
        window.location.href = this.getQuizReferrerLink || this.$getUrl('home');
        return;
      }
      const currentQuiz = this.getQuizList[this.getQuizCurrentIndex];
      const previousQuizIndex = this.getQuizList.findIndex((quiz) => quiz.id === currentQuiz.goBackStep);
      const eventIndex = previousQuizIndex === -1 ? this.getQuizCurrentIndex - 1 : previousQuizIndex;

      this.scrollToTop();
      this.$nextTick(() => {
        this.setQuizCurrentIndexAction(eventIndex);
      });
    },
  },
};
